import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-to-clipboard"
export default class CopyToClipboardController extends Controller<HTMLElement> {
  static values = { content: String }
  static classes = ["success"]

  declare contentValue: string
  declare successClass?: string

  async copy(event: MouseEvent) {
    event.preventDefault()
    this.reset()

    try {
      await navigator.clipboard.writeText(this.contentValue)
      if (this.successClass) {
        this.element.classList.add(this.successClass)

        // Remove the success class after 2 seconds
        setTimeout(() => {
          this.element.classList.remove(this.successClass!)
        }, 2000)
      }
    } catch (err) {
      console.error("Failed to copy text: ", err)
    }
  }

  reset() {
    if (this.successClass) {
      this.element.classList.remove(this.successClass)
    }
  }
}
